import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

interface SlideData {
  id: number;
  title: string;
  image: string;
  actionText: string;
  route: string; // Added route property
}

interface CardData {
  id: number;
  title: string;
  image: string;
  actionText: string;
  route: string; // Added route property
}

@Component({
  selector: 'app-recent-updates',
  imports: [CommonModule],
  templateUrl: './recent-updates.component.html',
  styleUrl: './recent-updates.component.scss',
  standalone: true
})
export class RecentUpdatesComponent implements OnInit, OnDestroy {
  currentSlide = 0;
  autoSlideInterval: any;
  autoSlideDelay = 5000;

  slides: SlideData[] = [
    {
      id: 1,
      title: 'RAG Chatbot',
      image: '../../../assets/home/recent-updates/ragchatbot.png',
      actionText: 'Read the Blog',
      route: '/tech-blogs/rag-chatbot'
    },
    {
      id: 2,
      title: 'Agentic AI in SDLC',
      image: '../../../assets/home/recent-updates/agentic-ai-in-sdlc.png',
      actionText: 'Read the Blog',
      route: '/tech-blogs/agentic-ai-in-sdlc'
    },
    {
      id: 3,
      title: 'Unified System Insurance',
      image: '../../../assets/home/recent-updates/unified-system-insurance.png',
      actionText: 'Read the Case Study',
      route: '/kalpita-case-studies/unified-system-insurance'
    }
  ];

  smallCards: CardData[] = [
    {
      id: 1,
      title: 'AI Agents In Enterprises',
      image: '../../../assets/home/recent-updates/latestBlog.png',
      actionText: 'Read the Blog',
      route: '/tech-blogs/ai-agents-in-enterprises'
    },
    {
      id: 2,
      title: 'Rise Of AI Agent',
      image: '../../../assets/home/recent-updates/latestWhitepaper.png',
      actionText: 'Read the White Paper',
      route: '/kalpita-white-papers/rise-of-ai-agent'
    },
    {
      id: 3,
      title: 'TechGeek',
      image: '../../../assets/home/recent-updates/latestTechgeek.png',
      actionText: 'Read the Techgeek',
      route: '/kalpita-tech-geek/techgeek-5'
    }
  ];

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.startAutoSlide();
  }

  ngOnDestroy(): void {
    this.stopAutoSlide();
  }

  goToSlide(slideIndex: number): void {
    if (slideIndex >= 0 && slideIndex < this.slides.length) {
      this.currentSlide = slideIndex;
      this.resetAutoSlide();
    }
  }

  nextSlide(): void {
    this.currentSlide = (this.currentSlide + 1) % this.slides.length;
    this.resetAutoSlide();
  }

  prevSlide(): void {
    this.currentSlide = this.currentSlide === 0 ? this.slides.length - 1 : this.currentSlide - 1;
    this.resetAutoSlide();
  }

  startAutoSlide(): void {
    this.autoSlideInterval = setInterval(() => {
      this.nextSlide();
    }, this.autoSlideDelay);
  }

  stopAutoSlide(): void {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
    }
  }

  resetAutoSlide(): void {
    this.stopAutoSlide();
    this.startAutoSlide();
  }

  onSlideClick(slide: SlideData): void {
    if (slide.route) {
      this.router.navigate([slide.route]);
      window.scrollTo(0, 0); // Ensure page scrolls to top
    }
  }

  onCardClick(card: CardData): void {
    if (card.route) {
      this.router.navigate([card.route]);
      window.scrollTo(0, 0); // Ensure page scrolls to top
    }
  }

  private touchStartX = 0;
  private touchEndX = 0;

  onTouchStart(event: TouchEvent): void {
    this.touchStartX = event.changedTouches[0].screenX;
    this.stopAutoSlide();
  }

  onTouchEnd(event: TouchEvent): void {
    this.touchEndX = event.changedTouches[0].screenX;
    this.handleSwipe();
    this.startAutoSlide();
  }

  private handleSwipe(): void {
    const swipeThreshold = 50;
    const swipeDistance = this.touchEndX - this.touchStartX;

    if (Math.abs(swipeDistance) > swipeThreshold) {
      if (swipeDistance > 0) {
        this.prevSlide();
      } else {
        this.nextSlide();
      }
    }
  }

  onKeyDown(event: KeyboardEvent): void {
    switch (event.key) {
      case 'ArrowLeft':
        this.prevSlide();
        break;
      case 'ArrowRight':
        this.nextSlide();
        break;
      case ' ':
      case 'Enter':
        event.preventDefault();
        this.stopAutoSlide();
        setTimeout(() => this.startAutoSlide(), 2000);
        break;
    }
  }
}